import type { PaginatedListMeta } from './pagination.types';

export interface TourSearchPayload {
  from_location: string;
  to_location: string;
  depart?: string;
  duration?: number;
  price_from?: string;
  price_to?: string;
  limit?: number;
  company?: string;
  companies?: string[];
}

export interface TourDurationRange {
  from?: string;
  to?: string;
}

export type TourDuration = string | number | TourDurationRange;

export interface TourItem {
  external_id?: string | number;
  discover_payload?: string | Record<string, unknown>;
  product_code?: string;
  name: string;
  description?: string;
  image_url?: string;
  duration?: TourDuration;
  price?: string | number;
  currency?: string;
  link?: string;
  supplier_name?: string;
  supplier_phone?: string;
  supplier_email?: string;
  supplier_address?: string;
  provider?: string;
  from_location?: string;
  to_location?: string;
  depart_date?: string;
}

export interface TourSearchResult extends PaginatedListMeta {
  results: TourItem[];
}

export interface TourSearchContextForSave {
  fromLocation: string;
  toLocation: string;
  departDate?: string;
  durationDays?: number;
}

export interface TourToIdeaPayload {
  external_id: string;
  discover_payload: string;
  product_code?: string;
  name: string;
  description?: string;
  image_url?: string;
  link?: string;
  price?: string;
  currency?: string;
  duration?: string;
  from_location?: string;
  to_location?: string;
  depart_date?: string;
  duration_days?: number;
}

export interface TourToIdeaResponse {
  code: string;
  message: string;
  idea_list_name: string;
}

export type DiscoverTourPriceRange = {
  min: string;
  max: string;
};

export type DiscoverTourFilters = {
  companyIds: string[];
  companySearch: string;
  priceRange: DiscoverTourPriceRange;
};

export const DISCOVER_TOUR_FILTERS_INITIAL: DiscoverTourFilters = {
  companyIds: [],
  companySearch: '',
  priceRange: { min: '', max: '' },
};

export type DiscoverTourCompany = {
  id: string;
  name: string;
};
